import Parse from "parse";
import { useEffect, useState } from "react";
import { Route_Type } from "../js/parsegenerated/Route_Type";

/**
 *
 * @returns All route types specified by GTFS.
 */
export function useRouteType() {
  const [types, setTypes] = useState<Route_Type[]>([]);
  const [reload, setReload] = useState(0);

  useEffect(() => {
    new Parse.Query(Route_Type).find().then(setTypes);
  }, [reload]);

  return [
    types,
    () => {
      setReload((x) => x + 1);
    },
  ] as [Route_Type[], () => void];
}
